import React, { useMemo } from "react";
import styled, { css } from "styled-components";

const TabIndicator = styled.div`
  position: absolute;
  height: 3px;
  background-color: #1f23ea;
  bottom: 0;
  left: 0;
  transition: all 0.2s;
`;

const Tab = styled.div`
  cursor: pointer;
  user-select: none;
  color: #1e1f46;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  text-wrap: balance;
  letter-spacing: 0px;
  text-align: center;
  transition: all 0.2s;
  ${(props) =>
    props.active
      ? "opacity: 1;"
      : css`
          opacity: 0.5;

          &:hover {
            opacity: 0.8;
          }
        `}
`;

const TabSliderContent = styled.div`
  flex-grow: 1;
  overflow: hidden;
`;

const TabBar = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  border-bottom: 1px solid #e3e6e8;
  margin: 20px 10px 0;
`;

const TabContent = styled.div`
  padding: 16px;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
`;

const ContentSlider = styled.div`
  display: flex;
  height: 100%;
  transition: all 0.2s;
`;

const TabSliderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: ${({ height }) => (height ? `${height}px` : "100%")};

  ${Tab}, ${TabIndicator} {
    width: ${(props) => (props.width - 20) / props.length}px;
  }

  ${TabSliderContent} {
    width: ${(props) => props.width}px;
  }

  ${TabContent} {
    width: ${(props) => props.width}px;
    min-width: ${(props) => props.width}px;
  }

  ${TabIndicator} {
    transform: translateX(${(props) => props.tabIndex * 100}%);
  }

  ${ContentSlider} {
    width: ${(props) => props.length * props.width}px;
    transform: translateX(-${(props) => props.tabIndex * props.width}px);
  }
`;

const TabHeadline = styled.div`
  width: 100%;
  background: blue;
  font-size: 20px;
  font-weight: bold;
  line-height: 30px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: white;
  display: flex;
  justify-content: center;
`;

const TabSlider = ({
  tabs,
  selectedTab,
  setSelectedTab,
  width,
  height = null,
  footer,
  children,
  headline = ""
}) => {
  const tabIndex = useMemo(() => tabs.findIndex((tab) => tab === selectedTab), [selectedTab, tabs]);

  return (
    <TabSliderWrapper width={width} length={tabs.length} tabIndex={tabIndex} height={height}>
      {headline && <TabHeadline>{headline}</TabHeadline>}

      <TabBar>
        <TabIndicator />

        {tabs.map((tab) => (
          <Tab key={tab} active={selectedTab === tab} onClick={() => setSelectedTab(tab)}>
            {tab}
          </Tab>
        ))}
      </TabBar>

      <TabSliderContent>
        <ContentSlider>{children}</ContentSlider>
      </TabSliderContent>
      {footer}
    </TabSliderWrapper>
  );
};

export { TabSlider, TabContent };
